export default __webpack_public_path__ + "static/media/ShortlistLightGreen.da7cffb9.svg";